<template>
    <div class="blog-comment-form-wrap">
        <h1>Write a comment</h1>
        <el-form
            ref="ruleFormRef"
            label-width="120px"
            class="blog-comment-form"
            label-position="top"
            v-model="comments"
        >
            <el-row>
                <el-col :span="12">
                    <el-form-item label="Your Name" prop="Your name">
                        <el-input v-model="comments.name" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Your Email" prop="Your Email">
                        <el-input v-model="comments.email" type="email" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Your Website" prop="Your Website">
                        <el-input v-model="comments.website" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Your Comment" prop="Your Comment">
                        <el-input
                        v-model="comments.content"
                        :rows="4"
                        type="textarea"
                    />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-button type="primary" class="btn theme-btn">Post Comment</el-button>
        </el-form>
    </div>
</template>

<script>
export default {
    name: 'CommentForm',
    data() {
        return {
            comments: {
                name: '',
                email: '',
                website: '',
                content: ''
            }
        }
    }
}
</script>